/**
 * Action configuration for Catalog Management
 */

import { RowAction, IgnoreReason } from '../types';

// Suggested ignore reasons (chip buttons)
export const IGNORE_REASONS: IgnoreReason[] = [
  'Duplicate product',
  'Invalid product',
  'Product already exists',
  'Product not required',
  'Data inconsistency',
];

// Row actions per tab
export const SKU_MATCHED_ACTIONS: RowAction[] = [
  { type: 'update', label: 'Update' },
  { type: 'ignore', label: 'Ignore' },
];

export const MPN_UPC_UNMAPPED_ACTIONS: RowAction[] = [
  { type: 'map-sku', label: 'Map SKU' },
  { type: 'ignore', label: 'Ignore' },
];

export const MPN_UPC_WITH_UPDATES_ACTIONS: RowAction[] = [
  { type: 'map-overwrite', label: 'Map & Overwrite' },
  { type: 'map', label: 'Map' },
  { type: 'ignore', label: 'Ignore' },
];

export const UNMATCHED_ACTIONS: RowAction[] = [
  { type: 'update', label: 'Update' },
  { type: 'create-new', label: 'Create New' },
  { type: 'ignore', label: 'Ignore Product' },
];

export const IGNORED_ACTIONS: RowAction[] = [
  { type: 'restore', label: 'Move to Original Source' },
];

// Bulk row actions dropdown options for SKU Matched tab
export const BULK_ROW_ACTIONS = [
  { label: 'Update', value: 'update' },
  { label: 'Ignore Update', value: 'ignore' },
];

// Bulk row actions for MPN/UPC Matched tab
export const MPN_UPC_BULK_ROW_ACTIONS = [
  { label: 'Map SKU', value: 'map_sku' },
  { label: 'Map & Update', value: 'map_override' },
  { label: 'Ignore', value: 'ignore' },
  { label: 'Create New', value: 'create_new' },
];

// Bulk row actions for Unmatched tab
export const UNMATCHED_BULK_ROW_ACTIONS = [
  { label: 'Update', value: 'update' },
  { label: 'Ignore Product', value: 'ignore' },
  { label: 'Create New', value: 'create_new' },
];

// Bulk row actions for Ignored Products tab
export const IGNORED_BULK_ROW_ACTIONS = [
  { label: 'Move to Original Source', value: 'restore' },
];
